import React from "react";
import potrait from "../images/you.png";
import { Link } from "react-router-dom";
import horizontal from "../images/horizontal.png";
import { BsArrowRight } from "react-icons/bs";
import resume from "../Mayowa-abikoye-resume.pdf";

const InformationMobile = () => {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          justifyContent: "start",
          margin: "7% auto",
          // border: "2px solid green",
          padding: "2%",
          width: "90%",
        }}
      >
        <h2 style={{ textAlign: "left", justifyItems: "left" }}>
          <span style={{ color: "white" }}>Mayowa is a</span>
          {/* <br /> */}
          <span style={{ color: "#C778DD" }}> BlockChain Engineer</span>
          {/* <br /> */}
          <span style={{ color: "white" }}> and</span>
          {/* <br /> */}
          <span style={{ color: "#C778DD" }}> Full-Stack Web Developer</span>
        </h2>
        <br />
        <h3 style={{ color: "#ABB2BF", textAlign: "justify" }}>
          I develop Applications that utilize both Blockchain and Non-Blockchain
          Technologies
        </h3>
        <button
          style={{
            border: "2px solid #C778DD",
            background: "#28282b",
            padding: "2% 4%",
            margin: "3% 0",
          }}
        >
          <Link
            to="/contacts"
            style={{ textDecoration: "none", color: "white", float: "start" }}
          >
            Contact Me
          </Link>
        </button>

        <div
          style={{
            textAlign: "left",
            marginTop: "15%",
            border: "2px solid #abb2bf",
            borderRadius: "10px",
          }}
        >
          <img
            src={potrait}
            alt="An image of the best blockchain dev in the world"
            style={{ padding: "3%  3%" }}
            // style={{
            //   width: "70%",
            //   maxWidth: "100%",
            //   display: "-webkit-box",
            //   marginLeft: "auto",
            //   marginRight: "auto",
            // }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "2%",
            }}
          >
            <div
              style={{
                width: "10px",
                height: "14px",
                background: "#C778DD",
                border: "0.50px #C778DD solid",
                display: "inline-block",
              }}
            ></div>
            <div style={{ display: "inline-block" }}>
              <Link
                to={resume}
                download="Mayowa-Abikoye_Resume"
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none", color: "white" }}
              >
                Download Resume
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div style={{ width: "90%", margin: "20% auto" }}>
        <div
          style={{ color: "white", textAlign: "center" }}
          className="quotations"
        >
          In a Different Class Of My Own
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: "2px solid #ABB2BF",
            float: "right",
            margin: "2% auto",
            padding: "2%",
            width: "fit-content",
            maxWidth: "90%",
          }}
        >
          <span style={{ color: "white" }}>Mayowa</span>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "90%",
          margin: "10% auto 0",
          // border: "2px solid orange",
          padding: "2%",
          flexDirection: "row",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            marginTop: "20%",
            // flexWrap: "wrap",
            // justifyContent: "start",
            alignItems: "center",
            // marginBottom: "1rem",
          }}
        >
          <span style={{ color: "#C778DD", marginRight: "0.5rem" }}>#</span>
          <h3
            style={{
              color: "white",
              fontWeight: "bolder",
              fontSize: "1.5rem",
              margin: 0,
            }}
          >
            Projects
          </h3>

          <img
            src={horizontal}
            alt=""
            style={{ width: "20%", maxWidth: "20%" }}
          />
        </div>

        <div
          style={{
            color: "white",
            textAlign: "center",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "20%",
          }}
        >
          <span>
            <Link to="/works">View all </Link>
          </span>
          <BsArrowRight />
        </div>
      </div>
    </>
  );
};

export default InformationMobile;
